import type { GuestRatingSummary } from '@apps/main/new-desktop/modules/customersRating';
import type { PriceCalendarState } from '@apps/main/new-desktop/modules/priceCalendar';
import type { PriceRibbonMonth } from '@apps/main/new-desktop/modules/priceRibbon';

import type { FullStars } from '@libs/trip-planner-interfaces';

export interface PeekPriceModalCalendar {
  priceCalendarState: PriceCalendarState;
  selectedMonth: string;
  months: PriceRibbonMonth[];
}

export const enum PeekPriceModalItineraryType {
  Placeholder = 'placeholder',
  HotelOnly = 'hotelOnly',
}

export type PeekPriceModalItinerary =
  | PeekPriceModalHotelOnlyItinerary
  | PeekPriceModalPlaceholderItinerary;

export interface PeekPriceModalHotelOnlyItinerary {
  type: PeekPriceModalItineraryType.HotelOnly;
  imageUrls: string[];
  dates: string;
  nights: string;
  price: string;
  paxes: string;
  hotelName: string;
  hotelDestination: string;
  hotelStars: FullStars;
  guestRating?: GuestRatingSummary;
}

export interface PeekPriceModalPlaceholderItinerary {
  type: PeekPriceModalItineraryType.Placeholder;
  hotelName: string;
}

export function isPeekPriceModalPlaceholderItinerary(
  itinerary: PeekPriceModalItinerary
): itinerary is PeekPriceModalPlaceholderItinerary {
  return itinerary.type === PeekPriceModalItineraryType.Placeholder;
}

export function isPeekPriceModalHotelOnlyItinerary(
  itinerary: PeekPriceModalItinerary
): itinerary is PeekPriceModalHotelOnlyItinerary {
  return itinerary.type === PeekPriceModalItineraryType.HotelOnly;
}
